function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6557f90b-1ede-4fc1-9743-4aaf2fb6668b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.27 41.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-2ba5dc38-aa04-4053-92b7-e04a7f090d2e",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.64,0h0C9.24,0,0,9.24,0,20.64h0c0,11.4,9.24,20.64,20.64,20.64h0c11.4,0,20.64-9.24,20.64-20.64h0C41.27,9.24,32.03,0,20.64,0ZM34.3,17.74h0c-.25.02-.5.04-.75.04-2.74,0-5.29-1.38-6.79-3.67v12.49c0,5.1-4.13,9.23-9.23,9.23s-9.23-4.13-9.23-9.23,4.13-9.23,9.23-9.23c.19,0,.38.02.57.03v4.55c-.19-.02-.38-.06-.57-.06-2.6,0-4.71,2.11-4.71,4.71s2.11,4.71,4.71,4.71,4.9-2.05,4.9-4.65l.05-21.22h4.35c.41,3.9,3.56,6.95,7.47,7.24v5.06Z",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTiktok);
export default __webpack_public_path__ + "static/media/activeTiktok.8da5151b389c90b7dd82753be0819bf7.svg";
export { ForwardRef as ReactComponent };